import AddressModel from './address.model'
import BaseModel from './base.model';

export default class UserModel extends BaseModel {
  id = 0;
  status = 0;
  is_approved = false;
  date_added = null;
  email_address = null;
  first_name = "";
  last_name = "";
  address = null;    
  session = null;
  token = null;
  mobile_number = null;
  id_number = null;

  constructor (data) {
    super();
    if (this.isEmpty(data)) return this;
    this.id = data.id;
    this.status = data.status;
    this.is_approved = data.is_approved || false;    
    this.date_added = data.date_added;
    this.email_address = data.email_address;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.address = new AddressModel(data.address);
    this.session = data.session;
    this.mobile_number = data.mobile_number;
    this.id_number = data.id_number;
    this.id_type = data.id_type;
    this.token = data.token;
  }
}
